require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./white-chocolate-and-raspberry.json") })
        }
      }, "path---white-chocolate-and-raspberry");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---white-chocolate-and-raspberry!./.cache/json/white-chocolate-and-raspberry.json
// module id = 495
// module chunks = 231608221292675